import * as React from 'react';

import { CardActionsLayout } from '../../components/CardActionsLayout';
import { ChatButtonContainer } from '../ChatButtonContainer';
import { ContactsPopupContainer } from '../ContactsPopupContainer';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { useOfferContext } from '../OfferContext';

export function CardActionsContainer() {
  const {
    author: { isFromLeadFactory },
    tracking: { onPhoneShow },
  } = useOfferContext();
  const [isContactsPopupOpened, setContactsPopupState] = React.useState(false);

  const onPhoneButtonClick = React.useCallback(() => {
    onPhoneShow();

    if (!isFromLeadFactory) {
      return;
    }

    setContactsPopupState(true);
  }, [isFromLeadFactory, onPhoneShow]);

  const onCloseContactsPopup = React.useCallback(() => {
    setContactsPopupState(false);
  }, []);

  return (
    <>
      <CardActionsLayout>
        <PhoneButtonContainer onClick={onPhoneButtonClick} />
        <ChatButtonContainer />
      </CardActionsLayout>
      {isContactsPopupOpened && <ContactsPopupContainer onClose={onCloseContactsPopup} />}
    </>
  );
}
